module.exports = __webpack_public_path__ + "img/AO.587faa78.png";